<template>
  <div class="content">
    <div class="toptitle">
      <span class="size36">企业责任</span>
      <p>Responsibility</p>
    </div>
    <div class="fix" @click="btn()">关于我们 &ensp;> &ensp;社会责任</div>
    <div class="title1">免费服务 致敬抗疫一线医疗工作者</div>
    <div class="box"></div>
    <div class="title2">
      新冠疫情爆发后，为向广大抗疫一线工作者致敬，公司实施合肥市抗疫一线工作者免费预约出行服务政策，2020年2月11日起，合肥市一线的医疗工作者、政府机构工作人员、社区工作者均可申请并享受免费出行服务。活动圆满完成3名医务工作者和1名社区工作者的乘车服务工作，共计免费服务57单；其中2名医务工作者和1名社区工作者拍摄相关致谢视频对我公司提供的公益活动表示感谢。
    </div>
    <img src="../../../static/images/about/1.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    btn() {
      this.$router.push({ name: "pcsocial" });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  // height: 100vh;
  // overflow-y: auto;
  font-weight: 400;
  color: #2d2d39;
  font-size: 14px;
  .toptitle {
    box-sizing: border-box;
    padding: 6% 0 0 4%;
    .size36 {
      font-size: 36px;
    }
    p {
      margin-left: 1px;
      font-size: 16px;
    }
  }
  .fix {
    cursor: pointer;
    width: 100%;
    height: 43px;
    line-height: 43px;
    margin-top: 10px;
    padding-left: 4%;
    box-sizing: border-box;
    background-color: #f2f2f2;
  }
  .title1 {
    width: 61.8%;
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    margin: 45px 0 0 4%;
  }
  .box {
    width: 61.8%;
    height: 1px;
    background-color: #e9e9e9;
    margin: 15px 0 0 4%;

  }
  .title2 {
    line-height: 25px;
    width: 61.8%;
    margin: 35px 0 0 4%;
  }
  img {
    width: 61.8%;
    margin: 30px 0 0 4%;
  }
}
</style>